import BudgetTreemap from "./budget-component";
import "./index.css";

export function App() {
	return (
		<div className="app">
			<BudgetTreemap />
		</div>
	);
}

export default App;
